import React from 'react';
import PropTypes from 'prop-types';
import { FormattedMessage } from 'react-intl';
import { guestVatSupportLink } from '../data/supportLinks';

const GuestTaxDetailsCopy = ({
  classNames = ''
}) => {
  return (
    <div className={`TaxDetailsCopy ${classNames}`}>
      <FormattedMessage
        id="hosting.guest_taxes.tax_details_copy"
        defaultMessage="Adding your tax registration may change how taxes are charged on your bookings. It’s the guest’s responsibility to keep all tax details up to date."
      />
      <a className="margin-sm-left underline" href={guestVatSupportLink}
        target="_blank" rel="noopener noreferrer">
        <FormattedMessage
          id='hosting.guest_taxes.learn_more_link'
          defaultMessage=" Learn more"
        />
      </a>
    </div>
  );
};

GuestTaxDetailsCopy.propTypes = {
  classNames: PropTypes.string
};

export default GuestTaxDetailsCopy;
